import { useState, useEffect } from "react";

import { NavLink } from "react-router-dom";
import CustomButton from "../kits/button/CustomButton.jsx";
import useAxios from "../../services/useAxios.tsx";
import ColorSchema from "../kits/Color/index";
import { ArrowLeftIcon } from "../kits/Icons";

import OrderList from "../order/OrderList.jsx";
export default function LastOrders() {
  const { execute: orderList } = useAxios("api2/orders_list");
  const [orders, setOrders] = useState([]);
  const [updater, setUpdater] = useState(false);
  useEffect(() => {
    orderList({ page: 1, count: 5 }).then(data => {
      let temp = [];
      temp = data.orders.map(value => {
        return {
          ...value,
          order_items: value.order_items.map(val => {
            return {
              ...val,
              OptionOrderItem: JSON.parse(val.OptionOrderItem)
            };
          })
        };
      });
      setOrders(temp.filter(v => v.type == 2));
    });
  }, [updater]);
  return (
    <>
      <div className="d-flex">
        <div
          className="d-flex align-items-center ms-auto"
          style={{
            color: ColorSchema.primary_custom,
            borderBottom: `1px solid ${ColorSchema.primary_custom}`
          }}
        >
          <NavLink to="/orders" className=" text-decoration-none px-1">
            <p color="info">مشاهده همه</p>
          </NavLink>
          <ArrowLeftIcon
            color={`${ColorSchema.primary_custom}`}
            style={{ width: 20, height: 20 }}
          />
        </div>
      </div>

      <div>
        {/* <OrderList content={orders} setContent={setOrders}></OrderList> */}
        <OrderList
          orderDataList={orders}
          setUpdate={setUpdater}
          // type="sell"
        ></OrderList>
      </div>
    </>
  );
}
